
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounting-terms",
      function () {
        return require("private-next-pages/accounting-terms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounting-terms"])
      });
    }
  